import api from './client';
import type { Template } from 'types';
import type { ListParams } from './types';

export const projectTemplatesApi = {
  list: async (params?: ListParams & { org_id?: string }): Promise<Template[]> => {
    const { data } = await api.get('/templates', { params });
    return data as Template[];
  },

  get: async (templateId: string): Promise<Template> => {
    const { data } = await api.get(`/templates/${templateId}`);
    return data;
  },

  create: async (template: any): Promise<Template> => {
    const { data } = await api.post('/templates', template);
    return data;
  },

  update: async (templateId: string, updates: any): Promise<Template> => {
    const { data } = await api.patch(`/templates/${templateId}`, updates);
    return data;
  },

  delete: async (templateId: string): Promise<void> => {
    await api.delete(`/templates/${templateId}`);
  },
};
